<template>
  <div class="home bg-light">
    <HeroSection>
<!--      <h1 class="display-12 text-white font-size-md-down-5 font-weight-semi-bold">-->
<!--        Compare <span class="text-warning">Lender</span> Deals...-->
<!--      </h1>-->
<!--      <p class="text-white">-->
<!--        We connect to more that {{ totalLenders | prettyNumber }} of the leading UK mortgage lenders and match their products to your unique requirements.-->
<!--        Browse our Lender directory to see what deals are available.-->
<!--      </p>-->
      <div class="row jjustify-content-lg-between jalign-items-lg-center text-white">
        <div class="col-lg-6 order-lg-1 mb-9 mb-lg-0">
          <h1 class="font-weight-medium text-white">
            Compare <span v-if="totalProducts != null"><span class="text-warning">{{ totalProducts | prettyNumber }}</span> Mortgages</span>
            <small><br>Find the one that suits you.</small>
          </h1>
          <p>We connect to the leading UK mortgage lenders and match their products to your unique requirements.</p>
          <ul class="list-unstyled text-white">
            <li class="media my-3">
              <div class="d-flex mt-1 mr-2">
                <span class="fas fa-check text-success"></span>
              </div>
              <div class="media-body">
                Get your own personalised mortgage offers
              </div>
            </li>
            <li class="media my-3">
              <div class="d-flex mt-1 mr-2">
                <span class="fas fa-check text-success"></span>
              </div>
              <div class="media-body">
                Match products to your unique requirements
              </div>
            </li>
            <li v-if="totalLenders != null" class="media my-3">
              <div class="d-flex mt-1 mr-2">
                <span class="fas fa-check text-success"></span>
              </div>
              <div class="media-body">
                Working with {{ totalLenders | prettyNumber }} leading UK mortgage lenders
              </div>
            </li>
          </ul>
          <!-- End List -->
        </div>
        <div class="col-lg-6 order-lg-2 p-1">
          <!-- SVG Shape -->
          <figure id="SVGgetAnswered" class="svg-preloader w-90">
            <img class="js-svg-injector" src="/assets/cmc/svg/illustrations/knowledgebase-community-1.svg" alt="Image Description"
                 data-parent="#SVGgetAnswered">
          </figure>
          <!-- End SVG Shape -->
        </div>
      </div>
    </HeroSection>
    <div class="container space-1 text-center">
<!--      <h1 class="divider divider-text">We're working with the UK's leading mortgage lenders to bring you the best deals available.</h1>-->
      <ul class="nav nav-segment nav-pills scrollbar-horizontal mb-2" role="tablist">
        <li class="nav-item cursor-pointer">
          <a class="nav-link active pointer" data-toggle="pill" role="tab" @click="setFilter('all')">All</a>
        </li>
        <li class="nav-item cursor-pointer">
          <a class="nav-link" data-toggle="pill" role="tab" @click="setFilter('banks')">Banks</a>
        </li>
        <li class="nav-item cursor-pointer">
          <a class="nav-link" data-toggle="pill" @click="setFilter('building-societies')">Building Societies</a>
        </li>
        <li class="nav-item cursor-pointer">
          <a class="nav-link" data-toggle="pill" @click="setFilter('top-uk-lender')">Top UK Lenders</a>
        </li>
      </ul>
      <AToZSelector 
          :values="aToZValues"
          :selected="aToZIndex"
          @selected="aToZIndex = $event"
          @deselected="aToZIndex = null"
          class="mb-4"></AToZSelector>
      <transition-group tag="div" name="fade-in-up" class="row">
        <div v-for="item in activeLenders" :key="item.uid" class="mb-5 col-md-12 text-center">
          <LenderCard :item="item"></LenderCard>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<style scoped>
  .cursor-pointer {
    cursor: pointer;
  }
</style>

<script>
  import { mapGetters } from "vuex";
  import LenderCard from "@/components/lenders/LenderCard";
  import HeroSection from "@/components/layout/HeroSection";
  import AToZSelector from "@/components/forms/AToZSelector";

  export default {
    name: "Lenders",
    
    components: {
      AToZSelector,
      HeroSection,
      LenderCard
    },

    data() {
      return {
        filterValue: "all",
        aToZIndex: null
      }
    },

    methods: {
      setFilter(value) {
        this.filterValue = value;
        this.aToZValue = null;
      },
      
      compareLenderNames(itemA, itemB) {
        let a = itemA.lenderName.toLowerCase();
        let b = itemB.lenderName.toLowerCase();
        
        return a > b ? 1 : a < b ? -1 : 0;
      }
    },
    
    computed: {
      ...mapGetters([
        "allLenders"        
      ]),
      
      activeLenders() {
        return this.aToZIndex == null
            ? this.selectedLenders
            : this.aToZIndex === "other"
                ? this.selectedLenders.filter(item => item.lenderName.toUpperCase()[0].charCodeAt(0) < 65 || item.lenderName.toUpperCase()[0].charCodeAt(0) > (65+25))
                : this.selectedLenders.filter(item => item.lenderName.toUpperCase()[0] === this.aToZIndex);
      },
      
      selectedLenders() {
        if (this.filterValue === "banks") return this.allLenders.filter(item => item.isBank).sort(this.compareLenderNames);
        if (this.filterValue === "building-societies") return this.allLenders.filter(item => item.isBuildingSociety).sort(this.compareLenderNames);
        if (this.filterValue === "top-uk-lender") return this.allLenders.filter(item => item.top10LenderRanking != null).sort(this.compareLenderNames);
        return this.allLenders.filter(item => item.lenderName != null).sort(this.compareLenderNames);
      },
      
      totalLenders() {
        return this.allLenders == null ? 0 : this.allLenders.length;
      },
      
      totalProducts() {
        if (this.allLenders == null) return 0;

        let total = 0;
        this.allLenders.forEach(item => total+= item.products.totalProducts);

        return total;
      },

      aToZValues() {
        let aToZ = {};
        let tmp = this.selectedLenders;
        for (let i = "A".charCodeAt(0); i <= "Z".charCodeAt(0); i++)
        {
          let items = tmp.filter(item => item.lenderName.toUpperCase().charCodeAt(0) === i);
          aToZ[String.fromCharCode(i)] = {
            active: items === undefined ? false: items.length > 0,
            count: items === undefined ? 0 : items.length
          };
        }
        let items = tmp.filter(
            item => item.lenderName.toUpperCase().charCodeAt(0) < "A".charCodeAt(0) ||
                item.lenderName.toUpperCase().charCodeAt(0) > "Z".charCodeAt(0)
        );
        aToZ["..."] = {
          category: "...",
          active: items === undefined ? false: items.length > 0,
          count: items === undefined ? 0 : items.length
        };

        return aToZ;
      }
    }
  }
</script>
